module.exports = __webpack_public_path__ + "static/9-c91fde98d82c1bbaf91ba5bf6723c58b.jpg";